import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import AddFutureItems from '../containers/AddFutureItems';
import { translationPrefix } from '../utils';
import css from './GenericDimensionPageStep.css';
import SearchableMultiSelect from './SearchableMultiSelect';
import StepCard from './StepCard';

const GenericDimensionPageStep = ({
    permissionDimension,
    setDimensionFilterValues = () => {},
    enableAddFuture = () => {},
    onStepValidationStatusChanged = () => {},
    translate = () => {},
}) => {
    const { name, displayName, values, selected } = permissionDimension;
    const dimension = (displayName || name || '').toLowerCase();
    const selectedValues = useMemo(() => selected.values || [], [selected.values]);

    useEffect(() => {
        const isValid = selectedValues.length > 0;
        onStepValidationStatusChanged({
            isValid,
            title: isValid
                ? ''
                : translate('STATIC.PAGES.TEAM_MEMBERS.SELECT_AT_LEAST_ONE_TOOLTIP', {
                      itemType: dimension,
                  }),
        });
    }, [onStepValidationStatusChanged, translate, selectedValues.length, dimension]);

    const allItems = useMemo(
        () =>
            values.map(value => ({
                id: value.name,
                name: value.name,
                displayName: value.displayName,
                selected: selectedValues.includes(value.name),
            })),
        [values, selectedValues]
    );

    const selectAll = shouldSelectAll => {
        setDimensionFilterValues(shouldSelectAll ? values.map(x => x.name) : []);
        if (shouldSelectAll) {
            enableAddFuture();
        }
    };

    const onItemSelected = (id, isSelected) => {
        if (!isSelected && selectedValues.includes(id)) {
            setDimensionFilterValues(selectedValues.filter(x => x !== id));
        } else if (isSelected && !selectedValues.includes(id)) {
            setDimensionFilterValues([...selectedValues, id]);
        }
    };

    return (
        <div className={css.container}>
            <StepCard
                className={css.stepCard}
                title="STATIC.PAGES.TEAM_MEMBERS.MANAGE_PERMISSIONS_PAGE.DIMENSION_FILTER.TITLE"
                titleTextReplace={{ dimension, count: selectedValues.length, total: values.length }}
                description="STATIC.PAGES.TEAM_MEMBERS.MANAGE_PERMISSIONS_PAGE.DIMENSION_FILTER.DESCRIPTION"
                descriptionTextReplace={{ dimension }}
            >
                <SearchableMultiSelect
                    className={css.multiSelectContainer}
                    allItems={allItems}
                    filteredItems={allItems}
                    onChange={onItemSelected}
                    selectAll={selectAll}
                    searchPlaceholder={translate(`${translationPrefix}.PLACEHOLDER.GENERIC_DIMENSION_SEARCH`, {
                        dimension,
                    })}
                    showIcon={false}
                />
            </StepCard>
            <AddFutureItems
                itemType="dimension_values"
                itemTypeData={{ dimension }}
                form={name}
                dimensionFilter
                className={css.addFutureItems}
            />
        </div>
    );
};

GenericDimensionPageStep.propTypes = {
    permissionDimension: PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayName: PropTypes.string,
        values: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                displayName: PropTypes.string.isRequired,
            })
        ).isRequired,
        selected: PropTypes.shape({
            values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
            addFuture: PropTypes.bool,
        }).isRequired,
    }).isRequired,
    setDimensionFilterValues: PropTypes.func,
    enableAddFuture: PropTypes.func,
    onStepValidationStatusChanged: PropTypes.func,
    translate: PropTypes.func,
};

export default GenericDimensionPageStep;
